import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    saveFactory,
    getAll,
    editData,
    getGroups,
    getFactoriesForDropdown,
    getFactoriesForDropdownByGroupID
};

async function saveFactory(data){
    let factory = {
        operationEntityID: 0,
        operationEntityCode: data.operationEntityCode,
        operationEntityName: data.operationEntityName.trim(),
        operationEntityLocation: data.operationEntityLocation.trim(),
        enityTypeID: 0,
        groupID: parseInt(data.groupID),
        isErpEnabled: data.isErpEnabled,
        isActive: data.isActive,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString()
    }
    const response = await CommonPost('/api/OperationEntity/SaveFactory', null, factory);
    return response;
}

async function getAll(){
    const response = await CommonGet('/api/OperationEntity/GetAllFactories', null);
    return response.data;
}

async function editData(data) {
    data.modifiedDate = new Date().toISOString();
    data.operationEntityName = data.operationEntityName.trim();
    data.operationEntityLocation = data.operationEntityLocation.trim();
    data.groupID = parseInt(data.groupID);
    
    const response = await CommonPost('/api/OperationEntity/UpdateFactory', null, data);
    return response;
}

async function getGroups() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"];
        }
    }
    return groupArray;
}

async function getFactoriesForDropdown(){
    var factoryArray = [];
    const response = await CommonGet('/api/Factory/GetAllFactories', null);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
        }
    }
    return factoryArray;
}

async function getFactoriesForDropdownByGroupID(groupID){
    
    return CommonGet('/api/OperationEntity/GetAllFactoriesByGroupID', 'groupID=' + groupID);
     
}